<template>
  <div>
    <div>
      <div style="float: left;">
        <h1> 项目列表</h1>
      </div>

      <div style="float: right;">
        <el-button icon="el-icon-plus" type="primary" @click="initAdd">添加新项目</el-button>
      </div>
    </div>


    <el-table
        :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
        style="width: 100%">


      <el-table-column
          prop="name"
          label="项目名"
          width="150">
        <template scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column
          prop="owner"
          label="项目创建者"
          width="150">
      </el-table-column>

      <el-table-column
          prop="createTime"
          label="项目创建时间">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="right">
        <template slot="header" slot-scope="{}">
          <el-input
              v-model="search"
              size="mini"
              placeholder="输入关键字搜索"/>
        </template>
        <template slot-scope="scope">
          <el-button
              size="mini"
              plain
              type="primary"
              @click="initEdit(scope.row,scope.$index)">编辑
          </el-button>
          <el-button
              size="mini"
              type="info"
              plain
              @click="rowClick(scope.row)">服务列表
          </el-button>
        </template>
      </el-table-column>

    </el-table>

    <el-dialog title="项目信息" :visible.sync="formVisible">
      <el-form :model="form">
        <el-form-item label="项目id" :label-width="formLabelWidth" v-show="inputVisible">
          <el-input v-model="form.id" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="项目名称" :label-width="formLabelWidth" prop="projectName">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="项目创建者" :label-width="formLabelWidth" v-show="inputVisible">
          <el-input v-model="form.owner" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="项目创建时间" :label-width="formLabelWidth" v-show="inputVisible">
          <el-input v-model="form.createTime" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmHandler">确 定</el-button>
        <el-button type="danger" @click="deleteProject" v-if="form.id">删 除</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {Apis} from "@/api";

export default {
  data() {
    return {
      tableData: [{
        id: "",
        name: "",
        owner: "",
        createTime: "",
      }],
      formLabelWidth: '120px',
      search: "",

      formVisible: false,
      inputVisible: false,
      index: 0,

      form: {
        id: "",
        name: "",
        owner: "",
        createTime: "",
      },
    }
  },
  methods: {

    //------------------------------------页面初始化函数--------------------------------------//
    //添加页面 初始化
    initAdd() {
      //隐藏部分输入框
      this.inputVisible = false

      //不再隐藏表单弹窗
      this.formVisible = true

      //重置表单
      this.resetForm()
    },

    //编辑页面 初始化
    initEdit(row, index) {
      //不再隐藏部分框
      this.inputVisible = true

      //不再隐藏表单弹窗
      this.formVisible = true

      //重置表单
      this.resetForm()

      //填充数据 复制
      this.form = JSON.parse(JSON.stringify(row))

      // console.log("initEdit")
      // console.log(row, index)

      //得到行号，方便更新成功之后更新列表中的数据
      this.index = index

    },

    //-----------------------------------工具函数----------------------------------------------//
    //重置表单字段
    resetForm() {
      this.form.id = ""
      this.form.name = ""
      this.form.owner = ""
      this.form.createTime = ""
    },

    //行中项目名的点击事件 跳转到服务页面
    rowClick(row) {
      this.$route.params.projectID = row.id;
      // console.log(this.$route.params.projectID)
      this.$router.push({name: "Services"})
    },


    //----------------------------------前端函数----------------------------------------------//
    //弹窗界面确认按钮的处理函数
    async confirmHandler() {
      //保证输入不空
      if (this.form.name === "" || this.form.name === undefined) {
        this.$message.error("项目名称不能为空");
        return
      }
      //不同情况对应不同接口
      if (this.inputVisible === false) {
        //添加项目
        await this.addProject()

      } else {
        //更新项目
        await this.updateProject()
      }

      // 隐藏弹窗界面
      this.formVisible = false
    },

    //-----------------------------------后端函数----------------------------------------------//
    //删除项目
    async deleteProject() {
      this.$confirm('此操作将永久删除项目(当项目下已无服务才能成功删除), 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const response = await Apis.Project.deleteProject(this.form.id)
        // console.log(response)
        if (response != null && response.errno === 0) {
          this.$message.success("项目删除成功!");

          //列表中删除该行
          this.tableData.splice(this.index, 1)
          this.formVisible = false
        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //新增项目
    async addProject() {
      const response = await Apis.Project.addProject(this.form.name)
      let project;
      if (response != null && response.errno === 0) {
        this.$message.success("项目信息添加成功!");
        project = response.data

        //列表头部新增一行
        this.tableData.unshift({
          id: project.projectID,
          name: project.projectName,
          owner: project.ownerName,
          createTime: project.createTime,
        })
      }
    },

    //更新项目
    async updateProject() {
      const response = await Apis.Project.updateProject(this.form.id, this.form.name)
      // console.log(response)
      if (response != null && response.errno === 0) {
        this.$message.success("项目更新成功");

        //更新列表中的值
        //先删除元素，然后将元素插入头部
        this.tableData.splice(this.index, 1)
        this.tableData.unshift(JSON.parse(JSON.stringify(this.form)))

      }
    },

  },
  created: async function () {
    //初始化主页面
    this.tableData = []

    //获取所有项目的基础数据
    const response = await Apis.Project.getProjects();
    //填充数据
    this.tableData = response.data || []
  }
}

</script>


<style scoped>
.op {
  text-align: right;
}
</style>